import { useState } from "react";
import { QrCode } from "lucide-react";

/**
 * QR rendered inside a white "stamp"; falls back to an icon if the verify
 * endpoint is unavailable (e.g. not yet deployed, or in demo mode).
 */
export default function QrStamp({ src, alt, size = 160, testId = "passport-qr" }) {
  const [err, setErr] = useState(false);
  return (
    <div className="bg-white p-2">
      {err ? (
        <div
          className="flex items-center justify-center text-black/70"
          style={{ width: size, height: size }}
        >
          <QrCode size={Math.round(size * 0.6)} strokeWidth={1} />
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          width={size}
          height={size}
          data-testid={testId}
          onError={() => setErr(true)}
        />
      )}
    </div>
  );
}
